import Register from "../components/Register";
import "../css/RegisterLogin.css";
import { TabView, TabPanel } from 'primereact/tabview';
import { useEffect, useState } from "react";
import Login from "../components/Login";
import NewLogin from "../components/NewLogin";
import colors from '../colors';




function RegisterLogin(props) {

    const [activeIndex, setActiveIndex] = useState(props.type);
    const [loginWithPass,setLoginWithPass] = useState(false);
    const [oldRegister,setOldRegister] = useState(false);

  return (
    <div className="main-layout">
      <div className="main-layout-pic-wrap">
        <img src={require("../images/login.png")} alt={process.env.REACT_APP_ALT} />
      </div>
      <div className="main-layout-form-wrap">


    <div id="newlogin-form">
      
    <img style={{width:"100",width:"100px"}} src={require("../images/logo.png")} alt={process.env.REACT_APP_ALT}></img>
    <h2>ورود / ثبت نام</h2>

      {!loginWithPass && !oldRegister && (<NewLogin/>)}

      {loginWithPass && !oldRegister && (<Login/>)}

      {oldRegister &&  (<Register/>)}

   
        <span style={{display:'flex',alignItems:'center', marginTop:"30px"}}>
                      
                      <span style={{width:'50%'}}>
                      { !oldRegister && (<span 
                            style={{background:"#219B9D4A",borderRadius:"10px",padding:'5px 10px',fontSize:'14px'
                              ,display:'flex',gap:"5px",cursor:'pointer',width:'fit-content'}}
                            onClick={ () => setLoginWithPass(!loginWithPass)}
                              >
                            <i className="pi pi-lock"></i>
                            {!loginWithPass ?
                              "ورود با کلمه عبور"
                              :"ورود با رمز یکبارمصرف"}
                            </span>   )}
                      </span>
                            <span 
                              style={{width:"50%",textAlign:"left",fontSize:'13px',fontFamily: "peyda-bold",cursor:'pointer',textAlign:"right"}}
                              onClick={() => setOldRegister(!oldRegister)}>
                              {!oldRegister ?
                                "از خارج از ایران ثبت نام می کنم"
                                :"از ایران ثبت نام می کنم"}
                                </span>


        </span>

    </div>
      

{/* <TabView className="tab-view" activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>

<TabPanel  id="logintab" header="ورود">
    <Login setTheme={props.setTheme}  />
    </TabPanel>
    <TabPanel id="registertab" header="عضویت">
    <Register />
    </TabPanel>
    
</TabView> */}


        
      </div>
    </div>
  );
}

export default RegisterLogin;
